<template>
    <div class="footer">
        <div class="footer__left">
            <div class="footer__group">
                <div class="footer__group-content">
                    <a :href="$keys.urls.neocc" :title="$keys.titles.neocc" target="_blank">{{ $keys.titles.neocc }}</a>
                </div>
            </div>
            <div class="footer__group">
                <div class="footer__group-content">
                    <a :href="$keys.urls.termsAndConditions" :title="$t.termsAndConditions" target="_blank">{{ $t.termsAndConditions }}</a>
                </div>
            </div>
            <div class="footer__group">
                <div class="footer__group-content">
                    <a :href="$keys.urls.privacyPolicy" :title="$t.privacyPolicy" target="_blank">{{ $t.privacyPolicy }}</a>
                </div>
            </div>
            <div class="footer__group">
                <span class="footer__group-label">{{ MilkyWayAttribution }}</span>
                <div class="footer__group-content">
                    <a :href="$keys.urls.ESAGaia" :title="$keys.titles.ESAGaia" target="_blank">{{ $keys.titles.ESAGaia }}</a>
                    <a :href="$keys.urls.CreativeCommons" :title="$keys.titles.CreativeCommons" target="_blank">{{ $keys.titles.CreativeCommons }}</a>
                </div>
            </div>
            <div class="footer__group">
                <span class="footer__group-label">{{ AsteroidShapes }}</span>
                <div class="footer__group-content">
                    <a :href="$keys.urls.DamitLink" :title="$keys.titles.DamitLink" target="_blank">{{ $keys.titles.DamitLink }}</a>
                    <span class="footer__text">{{ $t.and }} {{ $keys.titles.AsteroidSpaceLink }}</span>
                </div>
            </div>
            <div class="footer__group">
                <span class="footer__group-label">{{ AsteroidFamilyPortal }}</span>
                <div class="footer__group-content">
                    <a :href="$keys.urls.AsteroidFamilyPortal" :title="$keys.titles.AsteroidFamilyPortal" target="_blank">{{ $keys.titles.AsteroidFamilyPortal }}</a>
                </div>
            </div>
        </div>
        <div class="footer__right">
            {{ currentYear }} {{ attributiontext }} {{ $t.version }}: {{ version }}
        </div>
    </div>
</template>

<script>
import Config from '@/constants/config'

export default {
    name: 'CommonFooter',
    data() {
        return {
            currentYear: (new Date()).getFullYear(),
            MilkyWayAttribution: Config.MilkyWayAttribution,
            attributiontext: Config.attributionText,
            AsteroidFamilyPortal: Config.AsteroidFamilyPortal,
            AsteroidShapes: Config.AsteroidShapes,
        }
    },
    computed: {
        version() {
            return process.env.VUE_APP_VERSION;
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/styles/common/footer';
</style>
